// extracted by mini-css-extract-plugin
export default {"startingFromPrice":"styles-module__startingFromPrice__gcyT5","showTopLine":"styles-module__showTopLine__KktT3","viewRatesLink":"styles-module__viewRatesLink__Bjr84"};